import React, { useContext } from 'react';
import { prop, propEq, compose, reject, isNil, defaultTo, any, propOr } from 'ramda';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom';
import QStyles from '../../../_graphql/queries/documents/QStyles';
import { Title, Actions } from '../../../components';
import VersionsTree from '../../../components/VersionTree/VersionsTree';
import { associateVersions } from '../../../lib/versions';
import withUser, { UserContext } from '../../../withUser';
import { ROLES } from '../../../lib/rights';

const Styles = ({ user }) => {
  const history = useHistory();
  const { userTeam } = useContext(UserContext);
  const isAdmin = any(propEq(ROLES.admin, 'role'), propOr([], 'roles', userTeam));
  return (
    <>
      <Actions
        title={<Title title="Les styles de mon équipe" backTo="/equipe/parametrage" />}
        buttons={(
          <Button
            onClick={() => history.push('/equipe/styles/creer')}
            size="large"
            type="primary"
          >
            Créer un style
          </Button>
        )}
      />

      <div className="mt-6">
        <QStyles args={{ scope: 'global' }}>
          {styles => {
            styles = compose(
              reject(propEq(true, 'predefined')),
              reject(isNil),
              defaultTo([])
            )(styles);

            return (
              <VersionsTree
                items={associateVersions(styles, 'version.itemRootId')}
                editLinkPattern="/equipe/styles/:itemId/edition"
                suppressionLabel="Voulez-vous vraiment supprimer ce style ?"
                archiveLabel="Voulez-vous vraiment archiver ce style ?"
                userCanEdit={isAdmin}
                userId={prop('userId', user)}
                isStyle
              />
            );
          }}
        </QStyles>
      </div>
    </>
  );
};

export default withUser(Styles);
